import template from './payment-pay.html';
import angular from 'angular';
import to from 'await-to-js';
class PaymentPayController {
    /* @ngInject */
    constructor($element, payment, notificationFactory, $translate) {
        this.$element = $element;
        this.payment = payment;
        this.notificationFactory = notificationFactory;
        this.$translate = $translate;
    }
    $onInit() {
        this.createCardElement(this.connectedStripePublishable);
        const currencySymbol = this.currency === 'USD' ? '$' : this.currency;
        const currencyEnding = currencySymbol === '$' ? '' : ' ';
        this.displayCurrency = currencySymbol + currencyEnding;
    }
    async createCardElement(connectedStripePublishable) {
        const container = this.$element[0].querySelector('.stripe-card-element-container');
        this.cardElement = await this.payment.createCustomStripeCardElement(container, connectedStripePublishable);
        return this.cardElement;
    }
    async submit() {
        if (this.cardElement && this.cardElement.error) {
            this.notificationFactory.showCommon('error', this.cardElement.error.message, null, 3000);
            return;
        }
        this.status = 'processing';
        this.onProcessing();
        this.paymentPromise = this.cardElement.handleCardPayment(this.clientSecret);
        const [err] = await to(this.paymentPromise);
        if (!err) {
            this.onSuccess();
            this.status = 'success';
        }
        else {
            this.onError();
            this.errorMessage =
                err.message ||
                    this.$translate.instant('apps.payment.action.processing-error');
            this.status = 'error';
        }
    }
    cancel(notify) {
        this.onCancel({ notify: notify });
    }
}
class PaymentPayComponent {
    constructor() {
        this.controller = PaymentPayController;
        this.template = template;
        this.bindings = {
            errorMessage: '<?',
            status: '<',
            currency: '<',
            amount: '<',
            onSuccess: '&',
            onError: '&',
            onProcessing: '&',
            onCancel: '&',
            clientSecret: '<',
            connectedStripePublishable: '<',
            target: '<',
        };
    }
}
export default angular
    .module('doxy.realtime.components.payment.action.pay.paymentPay', [])
    .component('paymentPay', new PaymentPayComponent()).name;
